module.exports = __webpack_public_path__ + "img/construction.1e7cff68.jpg";